import * as ftp from './ftp';
import * as azure_blob_storage from './azure-blob-storage';
import * as html_to_pdf from './html-to-pdf';
import * as html_template from './html-template';
import * as report_hub from './report-hub';

export const filesNodes = {
  'ftp': ftp,
  'azure-blob-storage': azure_blob_storage,
  'html-to-pdf': html_to_pdf,
  'html-template': html_template,
  'report-hub': report_hub,
};
